import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=35a0ed30"
import script from "./PageCreate.vue?vue&type=script&lang=js"
export * from "./PageCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports